import { IApiError } from './interfaces';

export const isApiError = (maybeError: unknown): maybeError is IApiError =>
  typeof maybeError?.['message'] === 'string';
